import React from "react";
import {InputUtils} from "../../../../helpers";
import {NoticeDialog} from "../../../bounce-ui";

interface IBlockedACHContent {
  secondaryButtonText: string;
  onClickSecondary: () => void;
  gotItHandler: () => void;
}

export const BlockedACHContent = ({gotItHandler, onClickSecondary, secondaryButtonText}: IBlockedACHContent) => {
  return (
    <NoticeDialog
      title={"ACH Unavailable"}
      text={"Due to previous failed ACH payments, only a debit card can be used."}
      buttonText={"Got it"}
      onClick={gotItHandler}
      secondaryButtonText={InputUtils.prettierSnakeCaseSentence(secondaryButtonText)}
      onClickSecondary={onClickSecondary}
    />
  );
};
